// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default response => {
    const home = response?.data?.viewer?.home ?? {};
    const { layout, systemMessages } = home;
    return !(systemMessages ?? []).length && (layout ?? []).every(column => column.length === 0);
};
